module.exports = __webpack_public_path__ + "img/mtwikilogo.92b02fb.svg";